import { nextThemePreference, ThemePreference } from '../lib/theme';

const LABEL: Record<ThemePreference, string> = {
  system: 'Appearance: follows the system',
  light: 'Appearance: light',
  dark: 'Appearance: dark',
};

/**
 * One control, three states, cycled in place. A segmented switch would take
 * three times the width in a rail that has none to spare, and the state is
 * legible from the glyph alone.
 */
export function ThemeToggle({
  preference,
  onChange,
}: {
  preference: ThemePreference;
  onChange: (next: ThemePreference) => void;
}) {
  return (
    <button
      type="button"
      className="icon"
      title={`${LABEL[preference]} — click to switch`}
      aria-label={LABEL[preference]}
      onClick={() => onChange(nextThemePreference(preference))}
    >
      <svg
        viewBox="0 0 24 24"
        width="15"
        height="15"
        fill="none"
        stroke="currentColor"
        strokeWidth="1.75"
        strokeLinecap="round"
        strokeLinejoin="round"
        aria-hidden="true"
      >
        {preference === 'system' ? (
          <>
            <rect x="2.5" y="4" width="19" height="13" rx="2" />
            <path d="M9 20.5h6M12 17v3.5" />
          </>
        ) : preference === 'light' ? (
          <>
            <circle cx="12" cy="12" r="4" />
            <path d="M12 2.5v2M12 19.5v2M2.5 12h2M19.5 12h2M5.3 5.3l1.4 1.4M17.3 17.3l1.4 1.4M18.7 5.3l-1.4 1.4M6.7 17.3l-1.4 1.4" />
          </>
        ) : (
          <path d="M20.5 14.2A8.5 8.5 0 0 1 9.8 3.5a8.5 8.5 0 1 0 10.7 10.7z" />
        )}
      </svg>
    </button>
  );
}
